import parse from 'csv-parse/lib/es5/sync';
import ReservationRecord from './ReservationRecord';

/**
 * CSVテキストのパース
 *
 * @param {string} csv
 * @return {Array<ReservationRecord>}
 */
export default (csv) => {
    const records = parse(csv);

    return records.map((record) => {
        return ReservationRecord.create(record);
    });
};
